/**
 * Filter for Profile Name it the name is too long
 */
var filter = function () {
    return function (input) {
        var output = angular.isDefined(input) ? input : "";
        if (output.length > 65) {
            return output.substring(0, 65) + "...";
        }
        else {
            return output;
        }
    };
};
var ɵ0 = filter;
export var CompanyNameSettingsFilter = {
    name: 'companyNameSettingsFilter',
    filter: filter
};
export { ɵ0 };
//# sourceMappingURL=fourdotfive-company-name-settings.filter.js.map